<script lang="ts">
  import type { Snippet } from 'svelte';
  import AccessibilityPreferences from '$components/AccessibilityPreferences.svelte';
  import SharedCanvasContext from '$components/Background/SharedCanvasContext.svelte';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import { ResponsiveVars } from '@twist/core';
  import MobileNavModal from '$components/GlobalNav/MobileNavModal.svelte';
  import SearchModal from '$components/Search/SearchModal.svelte';
  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();

  const responsiveVars = new ResponsiveVars()
    .addFluid('container-padding-x', [
      ['lg', 'max', 68, 136],
      ['max', 136]
    ])
    .toCSS();

  let brandReskinEnabled = $derived(flagValue(FEATURE_FLAGS.BRAND_RESKIN));
  let globalSearchEnabled = $derived(flagValue(FEATURE_FLAGS.GLOBAL_SEARCH));
</script>

<div class={responsiveVars}>
  {#if brandReskinEnabled}
    {@render children?.()}
  {:else}
    <SharedCanvasContext>
      {@render children?.()}
    </SharedCanvasContext>
  {/if}

  <div id="modals"></div>
  <MobileNavModal />
  {#if globalSearchEnabled}
    <SearchModal />
  {/if}
  <AccessibilityPreferences />
</div>

<style lang="scss">
  @import 'src/scss/media';

  :global(.container) {
    width: 100%;
    max-width: $max-width-page;
    padding: 0 var(--twist-core-spacing-4);
    margin: 0 auto;
    box-sizing: border-box;

    @include at('lg') {
      padding: 0 var(--container-padding-x);
    }
  }
</style>
